import React, { useState, useEffect, useContext, useRef, createContext } from "react";
import $ from "jquery"
import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Main from "../components/layout/Main";
import logoVerticaleTheme from "../../src/assets/images/logoVerticaleTheme.png";
import Form from 'react-bootstrap/Form';
import { Button, Typography, Spin } from "antd";
import fileUploadIcon from "../../src/assets/images/fileUploadIcon.png";

import backArrow from "../assets/images/backArrow.png";
import Modal from 'react-bootstrap/Modal';
import leftBtnArrow from "../assets/images/leftBtnArrow.png";
import rightBtnArrow from "../assets/images/rightBtnArrow.png";
import plusIconTheme2 from "../assets/images/plusIconTheme2.png";
import clockIconFill from "../assets/images/clockIconFill.png";
import exitIcon from "../assets/images/exitIcon.png";
import useRequest from "../../src/hooks/useRequest"
import searchIcon from "../assets/images/searchIcon.png";
import DraggableNumberPicker from './DraggableNumberPickerx.js';

import { useNavigate, useLocation, useParams, Link } from "react-router-dom";
import { ShowToast, Severty } from "../helper/toast";

import ImprovedTimer from "./ImprovedTimer";
import { HoleContext } from "./HoleContext";
import LiveCam from "../components/LC/LiveCam.js";

function ScoreLeaderKeeping() {
  const location = useLocation();
  const { gameId } = useParams();
  let id = gameId;

  const [loading, setLoading] = useState(false);
  const addPlayerModalOpen = () => addPlayerModal(true);

  const [currentHole, setCurrentHole] = useState(1);
  const [friendList, setFriendList] = useState([])
  const { request } = useRequest();
  const navigate = useNavigate();
  const [newPostShow, newPostModal] = useState(false);
  const [show, scoreCardStepModal] = useState(false);
  const [Sdetail, setSdetail] = useState({})
  const scoreCardStepModalClose = () => scoreCardStepModal(false);
  const scoreCardStepModalOpen = () => scoreCardStepModal(true);
  const [scoreCard, setScoreCard] = useState()
  const [profile, setProfile] = useState({})
  const [gdetail, setGameDetail] = useState({})
  const closeAddScoreModal = () => { setAddScoreShow(false); };
  const newPostModalClose = () => newPostModal(false);
  const [addPlayerShow, addPlayerModal] = useState(false);
  const addPlayerModalClose = () => addPlayerModal(false);
  const [selectedFriends, setSelectedFriends] = useState([]);
  const [courseList, setCourseList] = useState([])

  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [addScore, setAddScore] = useState([])
  const [holeMax, setholeMax] = useState('')
  const [isEndGame, setIsEndGame] = useState(false);
  const [GameCreator, setGameCreator] = useState(null);
  const [showLiveCamera, setShowLiveCamera] = useState(false);

  const [addScoreShow, setAddScoreShow] = useState(false);
  const [serverRoundDuration, setServerRoundDuration] = useState(0);
  const [selectedValue, setSelectedValue] = useState('');
  const [userInitPar, setUserInitPar] = useState(-1);
  const [formEndData, setFormEndData] = useState({
    media: "",
    isPutts: false,
  });

  // Get logged in user
  let user = JSON.parse(localStorage.getItem('userProfile'));
  let userid = user?._id;

  const openGameEndPopup = () => {
    setIsEndGame(true);
  }

  const HandleSubmitEnd = (event) => {
    event.preventDefault();
    
    // For leaderboard mode, only create post for the logged-in user
    const loggedInUserGameDetail = gdetail.gameDetailsId.find(detail => detail.user._id === userid);
    
    if (!loggedInUserGameDetail) {
      ShowToast("User game details not found", Severty.ERROR);
      return;
    }

    var userPost = {
      title: "",
      description: "",
      course: gdetail.courseData.name,
      holes: gdetail.holes,
      media: formEndData.media,
      isPutts: formEndData.isPutts,
      putts: formEndData.isPutts ? loggedInUserGameDetail.putts : 0,
      isPrivate: gdetail.posts_privacy,
      isScore: true,
      score: loggedInUserGameDetail.totalScore,
      gameId: gameId,
      userID: userid,
    };

    if (!userPost.isPutts) {
      delete userPost.putts;
    }

    request({
      url: "/app/post/add-post",
      method: "POST",
      data: userPost,
      onSuccess: (data) => {
        ShowToast("Post added successfully", Severty.SUCCESS);
        navigate('/home');
        closeEndGame();
      },
      onError: (error) => {
        ShowToast("Failed to add post", Severty.ERROR);
      },
    });
  }

  const closeEndGame = () => {
    setIsEndGame(false);
  };

  const [selectedNumber, setSelectedNumber] = useState(4);
  const carouselRef = useRef(null);
  const numbers = Array.from({ length: 19 }, (_, i) => i + 1);
  const [carouselWidth, setCarouselWidth] = useState(400);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    course: "",
    holes: "",
    media: "",
    isScore: false,
    score: "",
  });

  const newPostModalOpen = () => {
    setFormData({
      title: "",
      description: "",
      course: gdetail?.course || "",
      holes: gdetail?.holes?.toString() || "18",
      media: "",
      isScore: false,
      score: "",
    });

    setSelectedValue(gdetail?.holes?.toString() || "18");
    newPostModal(true);
  };

  const [scoreData, setScoreData] = useState({
    userId: null,
    gameId: gameId,
    scoreValue: "",
    putts: 2,
    penalties: "",
    teeAccuracy: "",
    scoreRound: 0,
    par: 0,
    totalDuration: "",
    putDistance: 0,
    greenSideBunker: 0,
    fairwayBunker: 0,
    outOfBounds: 0,
    dropShot: 0,
    penaltyArea: 0,
    isFinished: false
  });

  const handlePuttsDistanceChange = (event) => {
    const newDistance = parseInt(event.target.value) || 0;
    setScoreData({ ...scoreData, putDistance: newDistance });
  };

  const handleScoreIncrement = (field) => {
    if ((field === 'greenSideBunker' || field === 'fairwayBunker' || field === 'dropShot' || field === 'penaltyArea' || field === 'outOfBounds') && scoreData[field] < 2) {
      setScoreData((prevScoreData) => ({
        ...prevScoreData,
        [field]: prevScoreData[field] + 1,
      }));
    }
  };

  const [holeContextValue, setHoleContextValue] = useState({
    currentHole,
    setCurrentHole,
    maxHoles: holeMax || 18,
    serverRoundDuration: 0
  });

  useEffect(() => {
    setHoleContextValue({
      currentHole,
      setCurrentHole,
      maxHoles: holeMax || 18,
      serverRoundDuration
    });
  }, [currentHole, holeMax, serverRoundDuration]);

  useEffect(() => {
    request({
      url: `app/game/game-detail/${id}`,
      method: "GET",
      onSuccess: (data) => {
        const duration = data.data.totalDuration;
        const normalizedDuration = typeof duration === 'number' ? duration :
          parseInt(duration, 10) || 0;
        const cappedDuration = normalizedDuration > 86400 * 365 ? 0 : normalizedDuration;

        setServerRoundDuration(cappedDuration);
        
        // For leaderboard mode, only show the logged-in user
        const filteredGameDetails = data.data.gameDetailsId.filter(detail => 
          detail.user._id === userid
        );

        const gameDetailsId = () => {
          return [...filteredGameDetails].sort((a, b) => {
            if (a.user._id === data.data.user._id) return -1;
            if (b.user._id === data.data.user._id) return 1;
            return 0;
          });
        };

        setGameCreator(data.data.user._id);
        const updatedGameDetails = { ...data.data, gameDetailsId: gameDetailsId() };
        setGameDetail(updatedGameDetails);

        setholeMax(data.data.holes);
        scoreDetail(data.data);

        findCurrentActiveHole(data.data);

        if (data.data.isFinished) {
          clearStorageAfterEndGame();
          openGameEndPopup();
        }
      },
      onError: (error) => {
        console.log(error);
      },
    });
    checkAllPlayersScored();
  }, []);

  const clearStorageAfterEndGame = () => {
    try {
      const storageKey = "activeGameHoles";
      const storedGames = JSON.parse(localStorage.getItem(storageKey)) || {};

      if (storedGames[`game_${gameId}`]) {
        delete storedGames[`game_${gameId}`];
        localStorage.setItem(storageKey, JSON.stringify(storedGames));
      }
    } catch (error) {
      console.error("Error clearing game data:", error);
    }
  };

  const findCurrentActiveHole = (gameData) => {
    const maxHoles = gameData.holes;
    let checkHole = 1;
    
    const checkNextHole = () => {
      request({
        url: `app/score/score-detail/${checkHole}/${gameId}`,
        method: "GET",
        onSuccess: (data) => {
          const allScores = data.data.data;
          
          // For leaderboard mode, we only care about the logged-in user's score
          const userScore = allScores.find(score => {
            if (typeof score.userId === 'string') {
              return score.userId === userid;
            } else if (score.userId && typeof score.userId === 'object') {
              return score.userId._id === userid;
            }
            return false;
          });

          const userHasScored = userScore && userScore.scoreValue !== null && userScore.scoreValue !== undefined;

          if (!userHasScored || checkHole === maxHoles) {
            setCurrentHole(checkHole);
            setShowLiveCamera(false);
            setTimeout(() => {
              setShowLiveCamera(true);
            }, 100);
            updateActiveHole(checkHole);
          } else if (checkHole < maxHoles) {
            checkHole++;
            checkNextHole();
          }
        },
        onError: (error) => {
          setShowLiveCamera(false);
          setTimeout(() => {
            setShowLiveCamera(true);
          }, 100);
          setCurrentHole(1);
        }
      });
    };

    checkNextHole();
  };

  const holes_max = holeMax;

  const handlechange = (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === 'checkbox' ? checked : value;

    setFormData({ ...formData, [name]: newValue });
    if (name in scoreData) {
      setScoreData({ ...scoreData, [name]: value });
    }
  };

  const openAddScoreModal = (userId) => {
    // Only allow the logged-in user to add score in leaderboard mode
    if (userId !== userid) {
      ShowToast("You can only add your own score in leaderboard mode", Severty.INFO);
      return;
    }

    const userIPar = gdetail.gameDetailsId.find(item => item.user._id === userId);
    setUserInitPar(Number(userIPar.userpar));
    
    request({
      url: `/common/scoreData/${gdetail?.course}/${gdetail?.courseTee?._id}/${currentHole}`,
      method: 'GET',
      onSuccess: (data) => {
        setSdetail(data.data);
        const parValue = data.data.par;
        setSelectedNumber(Number(parValue) || 4);

        const initialScoreData = {
          userId: userId,
          gameId: gameId,
          scoreValue: selectedNumber.toString(),
          putts: "2",
          penalties: "0",
          teeAccuracy: "",
          scoreRound: currentHole,
          par: data.data.par || 0,
          totalDuration: serverRoundDuration ? serverRoundDuration.toString() : "0",
          putDistance: "15",
          greenSideBunker: 0,
          fairwayBunker: 0,
          outOfBounds: 0,
          dropShot: 0,
          penaltyArea: 0,
          isFinished: currentHole === parseInt(holes_max)
        };

        setScoreData(initialScoreData);
        setAddScoreShow(true);
      },
      onError: (error) => {
        const fallbackScoreData = {
          userId: userId,
          gameId: gameId,
          scoreValue: selectedNumber.toString(),
          putts: "0",
          penalties: "0",
          scoreRound: currentHole,
          par: Sdetail?.par || 0,
          totalDuration: serverRoundDuration ? serverRoundDuration.toString() : "0",
          putDistance: "0",
          greenSideBunker: 0,
          fairwayBunker: 0,
          outOfBounds: 0,
          dropShot: 0,
          penaltyArea: 0,
          isFinished: currentHole === parseInt(holes_max)
        };
        setScoreData(fallbackScoreData);
        setAddScoreShow(true);
      }
    });
  };

  useEffect(() => {
    request({
      url: "app/friend/user-friend-list",
      method: "GET",
      onSuccess: (data) => {
        setFriendList(data?.data?.data);
      },
      onError: (error) => {
        console.log("Error in fetching friend List", error);
      }
    });

    setUserProfile();
    scoreInAddScore(gameId, currentHole);
    gameDetail();
  }, [location, gameId, currentHole]);

  const setUserProfile = () => {
    request({
      url: "app/user/get-profile",
      method: "GET",
      onSuccess: (data) => {
        setProfile(data.data);
      },
      onError: (error) => {
        console.log("Error fetching profile:", error);
      }
    });
  };

  const scoreDetail = async (data) => {
    const courseTee = data ? data?.courseTee?._id : gdetail?.courseTee?._id;
    const course = data ? data?.course : gdetail?.course;

    if (!course || !courseTee) {
      return;
    }

    request({
      url: `/common/scoreData/${course}/${courseTee}/${currentHole}`,
      method: 'GET',
      onSuccess: (data) => {
        setSdetail(data.data);
        setScoreData(prev => ({
          ...prev,
          scoreRound: data.data.hole,
          par: data.data.par
        }));
        setSelectedNumber(Number(data.data.par) || 4);
      },
      onError: (error) => {
        console.log("Error fetching score details:", error);
      },
    });
  };

  const updateActiveHole = (nextHole) => {
    const storageKey = "activeGameHoles";
    try {
      const storedGames = JSON.parse(localStorage.getItem(storageKey)) || {};
      storedGames[`game_${gameId}`] = {
        ...storedGames[`game_${gameId}`],
        ActiveHole: nextHole
      };
      localStorage.setItem(storageKey, JSON.stringify(storedGames));
    } catch (error) {
      console.error("Error updating active hole data:", error);
    }
  };

  const handleAddScore = async () => {
    const scoreDataToSubmit = { ...scoreData,
          scoreValue: selectedNumber, // Use the selectedNumber state

     };
    scoreDataToSubmit.scoreValue = parseInt(scoreDataToSubmit.scoreValue, 10);
    scoreDataToSubmit.putts = parseInt(scoreDataToSubmit.putts, 10);

    if (!scoreDataToSubmit.scoreRound) {
      scoreDataToSubmit.scoreRound = currentHole;
    }

    if (!scoreDataToSubmit.par && Sdetail?.par) {
      scoreDataToSubmit.par = Sdetail.par;
    }

    if (!scoreDataToSubmit.scoreValue) {
      scoreDataToSubmit.scoreValue = selectedNumber;
    }

    var sn = scoreDataToSubmit.scoreValue - Sdetail.par;
    scoreDataToSubmit.userpar = Number(sn) + Number(userInitPar);

    const storageKey = "activeGameHoles";
    const storedGames = JSON.parse(localStorage.getItem(storageKey)) || {};

    if (storedGames[`game_${gameId}`]) {
      const gameData = storedGames[`game_${gameId}`];
      scoreDataToSubmit.totalDuration = gameData[`hole${currentHole}`] || 0;
    }

    const isLastHole = parseInt(currentHole) === parseInt(holes_max);
    const allpscored = await checkAllPlayersScoredReturned();

    scoreDataToSubmit.isFinished = isLastHole && allpscored;

    if (currentHole < holes_max) {
      const nextHole = parseInt(currentHole) + 1;
      updateActiveHole(nextHole.toString());
    }

    request({
      url: "/app/score/add-score",
      method: "POST",
      data: scoreDataToSubmit,
      onSuccess: (data) => {
        scoreInAddScore(gameId, currentHole);
        gameDetail(gameId);
        closeAddScoreModal();
        checkAllPlayersScored();
      },
      onError: (error) => {
        console.log("Error adding score:", error);
      },
    });
  };

  const checkAllPlayersScoredReturned = () => {
    return new Promise((resolve, reject) => {
      request({
        url: `app/score/score-detail/${currentHole}/${gameId}`,
        method: "GET",
        onSuccess: (data) => {
          const allScores = data.data.data;
          
          // For leaderboard mode, we only care about the logged-in user's score
          const userScore = allScores.find(score => {
            if (typeof score.userId === 'string') {
              return score.userId === userid;
            } else if (score.userId && typeof score.userId === 'object') {
              return score.userId._id === userid;
            }
            return false;
          });

          const userHasScored = userScore && userScore.scoreValue !== null && 
                               userScore.scoreValue !== undefined && userScore.scoreValue !== 0;

          resolve(userHasScored);
        },
        onError: (error) => {
          console.log(error);
          reject(false);
        }
      });
    });
  };

  const checkAllPlayersScored = () => {
    request({
      url: `app/score/score-detail/${currentHole}/${gameId}`,
      method: "GET",
      onSuccess: (data) => {
        const allScores = data.data.data;
        
        // For leaderboard mode, we only care about the logged-in user's score
        const userScore = allScores.find(score => {
          if (typeof score.userId === 'string') {
            return score.userId === userid;
          } else if (score.userId && typeof score.userId === 'object') {
            return score.userId._id === userid;
          }
          return false;
        });

        const userHasScored = userScore && userScore.scoreValue !== null && 
                             userScore.scoreValue !== undefined && userScore.scoreValue !== 0;

        if (userHasScored && currentHole < holes_max) {
          updateActiveHole(currentHole + 1);
          setTimeout(() => {
            setShowLiveCamera(false);
            setTimeout(() => {
              setShowLiveCamera(true);
            }, 100);
            setCurrentHole(prevHole => prevHole + 1);
          }, 1000);
        } else if (userHasScored && currentHole == holes_max) {
          openGameEndPopup();
        }
      },
      onError: (error) => {
        console.log(error);
      }
    });
  };

  const gameDetail = () => {
    request({
      url: `app/game/game-detail/${id}`,
      method: "GET",
      onSuccess: (data) => {
        // For leaderboard mode, only show the logged-in user
        const filteredGameDetails = data.data.gameDetailsId.filter(detail => 
          detail.user._id === userid
        );

        const gameDetailsId = () => {
          return [...filteredGameDetails].sort((a, b) => {
            if (a.user._id === data.data.user._id) return -1;
            if (b.user._id === data.data.user._id) return 1;
            return 0;
          });
        };

        const updatedGameDetails = { ...data.data, gameDetailsId: gameDetailsId() };
        setGameDetail(updatedGameDetails);

        setServerRoundDuration(data.data.totalDuration || 0);
        scoreDetail(data.data);
        if (data.data.isFinished) {
          openGameEndPopup();
        }
      },
      onError: (error) => {
        console.log(error);
      },
    });
  };

  const handleLeftArrowClick = () => {
    if (currentHole > 1) {
      setCurrentHole(prevHole => {
        const newHole = prevHole - 1;
        return newHole;
      });
    }
    setShowLiveCamera(false);
    setTimeout(() => {
      setShowLiveCamera(true);
    }, 100);
  };

  const handleRightArrowClick = () => {
    const updatedHole = currentHole + 1;
    if (updatedHole <= holes_max) {
      setCurrentHole(updatedHole);
    }
    setShowLiveCamera(false);
    setTimeout(() => {
      setShowLiveCamera(true);
    }, 100);
  };

  const scoreInAddScore = (gameId, currentHole) => {
    request({
      url: `app/score/score-detail/${currentHole}/${gameId}`,
      method: "GET",
      onSuccess: (data) => {
        if (JSON.stringify(addScore) !== JSON.stringify(data.data.data)) {
          setAddScore(data.data.data);
        }
      },
      onError: (error) => {
        console.log(error);
      }
    });
  };

  const scoreCardData = async () => {
    request({
      url: `/app/score/get-score-game/${gameId}`,
      method: "GET",
      onSuccess: (data) => {
        navigate(`/gameDetail/${id}`, { state: { response: data.data } });
        setScoreCard(data.data);
      },
      onError: (error) => {
        console.log(error);
      },
    });
  };

  const handleCheckboxChange = (friendId) => {
    if (selectedFriends.includes(friendId)) {
      setSelectedFriends(selectedFriends.filter(id => id !== friendId));
    } else {
      setSelectedFriends([...selectedFriends, friendId]);
    }
  };

  const addPlayerData = () => {
    if (selectedFriends.length > 0) {
      const requestData = {
        id: profile?._id,
        players: selectedFriends ? selectedFriends : []
      };
      request({
        url: `app/game/joinPlayer`,
        method: "PUT",
        data: requestData,
        onSuccess: (data) => {
          addPlayerModalClose();
        },
        onError: (error) => {
          console.log("Error in joining player", error);
        }
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const postData = {
      ...formData,
      holes: selectedValue,
      course: gdetail.courseData?.name,
      isPrivate: gdetail.posts_privacy,
      gameId: gameId
    };

    if (!postData.isScore) {
      delete postData.score;
    }

    request({
      url: "/app/post/add-post",
      method: "POST",
      data: postData,
      onSuccess: (data) => {
        ShowToast("Post Added Successfully", Severty.SUCCESS);
        newPostModalClose();
        setFormData({
          title: "",
          description: "",
          course: "",
          holes: "",
          media: "",
          isScore: false,
          score: "",
        });
      },
      onError: (error) => {
        console.log(error);
      },
    });
  };

  const fileUploads = (event) => {
    setLoading(true);
    const file = event.target.files[0];
    const formdata = new FormData();
    formdata.append('image', file);
    request({
      url: "/common/image-upload",
      method: "POST",
      data: formdata,
      onSuccess: (data) => {
        setFormData({ ...formData, media: data.data.upload });
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
      },
    });
  };

  const fileUploadsEnd = (event) => {
    setLoading(true);
    const file = event.target.files[0];
    const formdata = new FormData();
    formdata.append('image', file);
    request({
      url: "/common/image-upload",
      method: "POST",
      data: formdata,
      onSuccess: (data) => {
        setFormEndData({ ...formData, media: data.data.upload });
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
      },
    });
  };

  return (
    <>
      <HoleContext.Provider value={holeContextValue}>
        <Main>
          <section className="home-wrap px-2 pb-2 container-fluid">
            <div className="row g-0">
              <div className="col-12">
                <div className="pagreHeader">
                  <div className="pageHeadign d-flex align-items-center gap-3 mb-3">
                    <button onClick={handleOpenModal} className="btn backBtn bg-transparent border-0 shadow-none p-0 d-flex">
                      <img className="h-100" src={backArrow} />
                    </button>
                    <Modal show={showModal} onHide={handleCloseModal}>
                      <Modal.Header closeButton>
                        <Modal.Title>Confirmation</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>Are you sure you want to quit?</Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                          No
                        </Button>
                        <Button
                          variant="primary"
                          onClick={() => {
                            navigate("/play");
                            handleCloseModal();
                          }}
                        >
                          Yes
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    <div className="txt">Score Keeping</div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="row g-2">
                  <div className="col-12">
                    <div className="eventcard mb-2 d-flex flex-column" style={{ borderRadius: 0, margin: 0, padding: 0 }}>
                      <div className="cardHead py-2 border-bottom bg-white" style={{ borderRadius: 0 }}>
                        <div className="holeHeading d-flex align-items-center justify-content-between px-2 py-1">
                          <button type="button" className="btn p-0 bg-transparent border-0" onClick={handleOpenModal}>
                            <img className="h-100" src={exitIcon} alt="Exit" />
                          </button>
                          <div className="d-flex align-items-center gap-2">
                            <button type="button" className="btn p-0 bg-transparent border-0" onClick={() => handleLeftArrowClick()}>
                              <img className="h-100" src={leftBtnArrow} alt="Previous" />
                            </button>
                            <div className="text fs-6 fw-medium text-dark">Hole {currentHole}</div>
                            <button type="button" className="btn p-0 bg-transparent border-0" onClick={() => handleRightArrowClick()}>
                              <img className="h-100" src={rightBtnArrow} alt="Next" />
                            </button>
                          </div>
                          <div className="invisible">
                            <img className="h-100" src={exitIcon} alt="Placeholder" />
                          </div>
                        </div>
                        <div className="text-muted fs-14 text-center pb-1">Par {Sdetail?.par} Yards {Sdetail?.value} l {Sdetail?.handicap}</div>
                      </div>

                      <div className="cardBody py-2 px-2">
                        <div className="w-100 d-flex align-items-center">
                          <div className="d-flex align-items-center gap-2">
                            <img src={clockIconFill} alt="Clock" />
                            <ImprovedTimer serverRoundDuration={serverRoundDuration} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="eventcard bg-white" style={{ padding: '0.5rem' }}>
                        {gdetail?.gameDetailsId?.map((list, index) => {
                          // Only show the logged-in user in leaderboard mode
                          if (list?.user?._id !== userid) return null;
                          
                          const userScore = addScore.find(score => {
                            if (typeof score.userId === 'string') {
                              return score.userId === list?.user?._id;
                            } else if (score.userId && typeof score.userId === 'object') {
                              return score.userId._id === list?.user?._id;
                            }
                            return false;
                          });
                          
                          const hasScored = userScore && userScore.scoreValue !== null && userScore.scoreValue !== undefined;
                          
                          return (
                            <div
                              className="playerItem"
                              key={list?.user?._id || index}
                              style={{
                                position: 'relative',
                                height: '60px',
                                paddingTop: '5px',
                                paddingBottom: '5px'
                              }}
                            >
                              <div
                                style={{
                                  position: 'absolute',
                                  left: '0',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px',
                                  maxWidth: 'calc(100% - 100px)',
                                  overflow: 'hidden'
                                }}
                              >
                                <div
                                  className="imgOuter rounded-circle overflow-hidden"
                                  style={{
                                    width: '50px',
                                    height: '50px',
                                    flexShrink: 0
                                  }}
                                >
                                  <img
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    src={
                                      list?.user?.profilePic
                                        ? `https://pwabucket1.s3.amazonaws.com/${list?.user?.profilePic}`
                                        : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                          list?.user?.name
                                        )}&size=256`
                                    }
                                    alt={list.name}
                                  />
                                </div>
                                <div style={{ overflow: 'hidden', minWidth: 0 }}>
                                  <div className="fs-14 fw-medium text-dark" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {list?.user?.name}
                                  </div>
                                  <div className="text-muted fs-12" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {list?.totalScore}
                                    {list?.userpar === 0 ? ` (E)` : ` (${Math.abs(list?.userpar)}${list?.userpar > 0 ? '+' : '-'})`}
                                  </div>
                                </div>
                              </div>

                              <div
                                style={{
                                  position: 'absolute',
                                  right: '0',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  width: '90px'
                                }}
                              >
                                <Button
                                  disabled={hasScored}
                                  className="btn btnOutlineTheme2 p-1 fs-12"
                                  style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                  onClick={() => openAddScoreModal(list?.user?._id)}
                                >
                                  <img src={plusIconTheme2} style={{ width: '14px', marginRight: '2px' }} />
                                  {hasScored ? (
                                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                      {userScore.scoreValue}
                                    </span>
                                  ) : (
                                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                      Add Score
                                    </span>
                                  )}
                                </Button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="d-md-none w-100 mt-4 mb-5 pb-3">
                <div className="d-flex justify-content-between">
                  <Button className="btn btnOutlineTheme2" onClick={() => scoreCardData()}>
                    Scoreboard
                  </Button>
                  <Button className="btn btnOutlineTheme2" onClick={newPostModalOpen}>
                    Add Post
                  </Button>
                </div>
              </div>

              <div className="d-md-none w-100 mt-4 mb-5 pb-3">
                <div className="d-flex justify-content-between">
                  {(gdetail?.course && showLiveCamera) ? (
                    <>
                      <LiveCam gdetail={gdetail} />
                    </>
                  ) : null}
                </div>
              </div>

              <div className="col-12 mt-3 d-none d-md-block">
                <Button className="btn btnOutlineTheme2 me-2" onClick={() => scoreCardData()}>
                  Scoreboard
                </Button>
                <Button className="btn btnOutlineTheme2" onClick={newPostModalOpen}>
                  Add Post
                </Button>
              </div>
            </div>
          </section>
        </Main>
      </HoleContext.Provider>

      <Modal show={addPlayerShow} className="headerModals" onHide={addPlayerModalClose} centered>
        <Modal.Header className="p-sm-4 p-3 position-relative justify-content-center" closeButton>
          <Modal.Title>
            <img src={logoVerticaleTheme} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-sm-4 p-3">
          <Form className="row gap-12">
            <Form.Group className="col-12 position-relative">
              <Form.Label htmlFor="contactSearch" style={{ cursor: "pointer" }} className="position-absolute top-0 bottom-0 my-auto end-0 me-3 d-flex align-items-center justify-content-center">
                <img src={searchIcon} />
              </Form.Label>
              <Form.Control className="pe-5"
                type="search"
                id="contactSearch"
                placeholder="Search by username, email or Handicap ID"
                aria-describedby="passwordHelpBlock"
              />
            </Form.Group>
            <Form.Group className="col-md-12 selectPlayerOuter">
              {friendList.map((list) => (
                <Form.Check
                  key={list.id}
                  className="selectPlayerCheck m-0 p-0 d-flex align-items-center justify-content-between flex-row-reverse"
                  name="group1"
                  type="checkbox"
                  id={`player_${list.id}`}
                  onChange={() => handleCheckboxChange(list?._id)}
                  checked={selectedFriends.includes(list?._id)}
                  label={
                    <div className="playerPro d-flex align-items-center gap-2">
                      <div className="playerImg overflow-hidden rounded-circle">
                        <img className="w-100 h-100" src={
                          list?.profilePic
                            ? `https://pwabucket1.s3.amazonaws.com/${list?.profilePic}`
                            : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                              list?.name
                            )}&size=256`
                        } alt="Avatar" />
                      </div>
                      <div className="detail">
                        <div className="name">{list.name}</div>
                        <div className="dec mt-1">{list && list.city}, {list && list.state}</div>
                      </div>
                    </div>
                  }
                />
              ))}
            </Form.Group>

            <Form.Group className="col-12 mt-4 text-end">
              <button type="button" className="btn btnStyle1 btnTheme1 shadow-none px-5 w-100" onClick={addPlayerData}>Add Players</button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
      
      <Modal
        show={newPostShow}
        size="lg"
        className="headerModals"
        onHide={newPostModalClose}
        centered
      >
        <Modal.Header
          className="p-4 position-relative justify-content-center"
          closeButton
        >
          <Modal.Title>
            <img src={logoVerticaleTheme} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form className="row g-2" onSubmit={handleSubmit}>
            <Form.Label className="col-12 mb-0">New Post</Form.Label>
            <div className="col-12 mb-0">
              <div className="row">
                <div className="col-12 col-md-6">
                  <Form.Group
                    controlId="formFile"
                    className="uploadFileOuter w-100 h-100"
                  >
                    <Form.Label className="w-100 h-100 d-flex align-items-center justify-content-center">
                      <div className="uploadFile text-center profile-upload">
                        <Spin spinning={loading} size="large">
                          <div className="imgOuter">
                            {formData?.media && formData.media.endsWith('.mp4') ? (
                              <video src={`https://pwabucket1.s3.amazonaws.com/${formData.media}`} autoPlay="true" type="video/mp4" />
                            ) : (
                              <img src={formData?.media ? `https://pwabucket1.s3.amazonaws.com/${formData?.media}` : fileUploadIcon} />
                            )}
                          </div>
                          <div className="txt mt-3">Upload Img or video</div>
                        </Spin>
                      </div>
                    </Form.Label>
                    <Form.Control className="d-none" type="file" name="media" onChange={fileUploads} />
                  </Form.Group>
                </div>
                <div className="col-12 mt-md-0 mt-3 col-md-6">
                  <div className="row gap-12">
                    <Form.Group className="col-12">
                      <Form.Control
                        className="sahdow-none"
                        type="text"
                        name="title"
                        onReset={Form}
                        required="title"
                        placeholder="Title"
                        onChange={handlechange}
                        value={formData.title || ""}
                      />
                    </Form.Group>
                    <Form.Group className="col-12 position-relative">
                      <Form.Control
                        as="textarea"
                        className="sahdow-none"
                        type="text"
                        onReset={Form}
                        name="description"
                        placeholder="Description"
                        onChange={handlechange}
                        value={formData.description || ""}
                        rows={3}
                      />
                    </Form.Group>
                    <Form.Group controlId="formCourse">
                      <Form.Label>Course</Form.Label>
                      <Form.Control
                        as="select"
                        name="course"
                        required="course"
                        onReset={Form}
                        value={formData.course || ""}
                        onChange={handlechange}
                      >
                        <option value="">Select Course</option>
                        {courseList.map((course) => (
                          <option key={course.id} value={course.id}>
                            {course.name}
                          </option>
                        ))}
                        {gdetail?.course && !courseList.find(c => c.id === gdetail.course) && (
                          <option value={gdetail.course}>
                            {gdetail.courseData?.name || "Current Course"}
                          </option>
                        )}
                      </Form.Control>
                    </Form.Group>

                    <Form.Group className="col-12">
                      <Form.Label>Holes</Form.Label>
                      <Form.Select
                        aria-label="Select holes"
                        name="holes"
                        value={selectedValue}
                        onChange={(e) => setSelectedValue(e.target.value)}
                      >
                        <option value="">Select Hole</option>
                        <option value="9">Hole 9</option>
                        <option value="18">Hole 18</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="col-12 mt-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <Form.Label className="mb-0">Is this a score post?</Form.Label>
                        <Form.Check
                          type="switch"
                          id="score-switch"
                          name="isScore"
                          checked={formData.isScore}
                          onChange={(e) => setFormData({ ...formData, isScore: e.target.checked })}
                        />
                      </div>
                    </Form.Group>

                    {formData.isScore && (
                      <Form.Group className="col-12 mt-2">
                        <Form.Label>Score</Form.Label>
                        <Form.Control
                          type="number"
                          name="score"
                          placeholder="Enter your score"
                          value={formData.score}
                          onChange={handlechange}
                          min="1"
                          required
                        />
                      </Form.Group>
                    )}

                    {currentHole && (
                      <Form.Group className="col-12 mt-2">
                        <div className="current-hole-info p-2 border rounded">
                          <div className="fw-medium">Current Hole: {currentHole}</div>
                          {addScore && addScore.length > 0 && (
                            <div className="small text-muted">
                              Scores: {addScore.map(score => score.scoreValue).filter(Boolean).join(', ')}
                            </div>
                          )}
                        </div>
                      </Form.Group>
                    )}
                    <Form.Group className="col-12 mt-4 text-end">
                      <button
                        type="submit"
                        className="btn btnStyle1 btnTheme1 shadow-none px-5 text-center w-100"
                      >
                        Post
                      </button>
                    </Form.Group>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={addScoreShow} onHide={closeAddScoreModal} className="headerModals" centered>
        <Modal.Body>
          <div className="headding-modal">
            <h6>Score Tracker</h6>
          </div>
          <div className="modal-card-01">
            <div className="score-headding">
              <h6>Score</h6>
            </div>
            <div
              className="number-carousel"
              ref={carouselRef}
              style={{
                width: `${carouselWidth}px`,
                margin: "0 auto",
                overflow: "hidden",
              }}
            >
              <DraggableNumberPicker
                initialValue={selectedNumber}
                onNumberChange={(value) => {
                  setSelectedNumber(value);
                  setScoreData(prev => ({ ...prev, scoreValue: value.toString() }));
                }}
              />
            </div>
          </div>

          <div className="modal-card-01">
            <div className="score-headding">
              <h6>Putts</h6>
            </div>
            <div className="putts-type">
              <ul>
                {[0, 1, 2, 3, 4, 5].map(value => (
                  <li key={value} className={scoreData.putts === value.toString() ? 'active' : ''} onClick={() => setScoreData(prev => ({ ...prev, putts: value.toString() }))}>
                    {value}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="modal-card-01">
            <div className="score-headding d-flex justify-content-between">
              <h6>1st Putts Distance</h6>
              <h6>{scoreData.putDistance} FT</h6>
            </div>
            <div className="putts-type-range">
              <input
                type="range"
                className="form-range"
                id="customRange1"
                min="0"
                max="30"
                value={scoreData.putDistance}
                onChange={handlePuttsDistanceChange}
              />
            </div>
          </div>

          <div className="single-post-dtl mt-5">
            <div className="score-post" onClick={() => handleScoreIncrement('greenSideBunker')}>
              <div className="post-info-ic">{scoreData.greenSideBunker}</div>
              <span>Greenside Bunker</span>
            </div>

            <div className="score-post" onClick={() => handleScoreIncrement('fairwayBunker')}>
              <div className="post-info-ic">{scoreData.fairwayBunker}</div>
              <span>Fairway Bunker</span>
            </div>

            <div className="score-post" onClick={() => handleScoreIncrement('outOfBounds')}>
              <div className="post-info-ic">{scoreData.outOfBounds}</div>
              <span>Out of Bounds</span>
            </div>

            <div className="score-post" onClick={() => handleScoreIncrement('dropShot')}>
              <div className="post-info-ic">{scoreData.dropShot}</div>
              <span>Drop shot</span>
            </div>

            <div className="score-post" onClick={() => handleScoreIncrement('penaltyArea')}>
              <div className="post-info-ic">{scoreData.penaltyArea}</div>
              <span>Penalty Area</span>
            </div>
          </div>

          <div className="btnGroup d-flex flex-column flex-sm-row align-items-center gap-3 mt-4">
            <Button type="button" onClick={closeAddScoreModal} className="btn btnStyle1 btnOutlineTheme1 btnWidth shadow-none px-3 w-100 d-flex align-items-center gap-1 justify-content-center">Cancel</Button>
            <Button type="button" onClick={handleAddScore} className="btn btnStyle1 btnTheme1 btnWidth shadow-none px-3 w-100">Add</Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={isEndGame} onHide={closeEndGame}>
        <Modal.Header closeButton>
          <Modal.Title>Game Finished</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {gdetail?.gameDetailsId
            ?.filter(player => player.user._id === userid)
            .map(player => (
              <Form className="row g-2" onSubmit={HandleSubmitEnd}>
                <div className="d-flex justify-content-center mb-4">
                  <Form.Label className="text-center mx-4">
                    <div className="score-post">
                      <div className="post-info-ic">{player.totalScore}</div>
                      <span style={{ fontSize: "18px", fontWeight: "600" }}>Score</span>
                    </div>
                  </Form.Label>
                  <Form.Label className="text-center mx-4">
                    <div className={`score-post ${!formEndData.isPutts ? "opacity-50" : ""}`}>
                      <div className="post-info-ic">{player.putts}</div>
                      <span style={{ fontSize: "18px", fontWeight: "600" }}>Putts</span>
                    </div>
                  </Form.Label>
                </div>

                <div className="col-12 mb-4">
                  <Form.Group>
                    <div className="d-flex align-items-center">
                      <div
                        className="checkbox-container me-3"
                        style={{
                          padding: "6px",
                          borderRadius: "6px",
                          border: "2px solid #1890ff",
                          backgroundColor: "#fff",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          id="include-putts-checkbox"
                          checked={formEndData.isPutts}
                          onChange={(e) => setFormEndData({ ...formEndData, isPutts: e.target.checked })}
                          className="form-check-lg"
                          style={{
                            transform: "scale(1.8)",
                            margin: "0",
                            cursor: "pointer"
                          }}
                        />
                      </div>
                      <p className="mb-0" style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        lineHeight: "1.4"
                      }}>
                        Your Total Putts Are {player.putts} for this round, do you want to post it with the score?
                      </p>
                    </div>
                  </Form.Group>
                </div>

                <div className="col-12 mb-4 d-flex justify-content-center">
                  <div className="col-10 col-md-8 text-center">
                    <Form.Group
                      controlId="formFile"
                      className="uploadFileOuter w-100"
                    >
                      <Form.Label className="w-100 d-flex align-items-center justify-content-center">
                        <div className="uploadFile text-center profile-upload">
                          <Spin spinning={loading} size="large">
                            <div className="imgOuter">
                              {formEndData?.media && formEndData.media.endsWith('.mp4') ? (
                                <video src={`https://pwabucket1.s3.amazonaws.com/${formEndData.media}`} autoPlay="true" type="video/mp4" />
                              ) : (
                                <img src={formEndData?.media ? `https://pwabucket1.s3.amazonaws.com/${formEndData?.media}` : fileUploadIcon} />
                              )}
                            </div>
                            <div className="txt mt-3" style={{ fontWeight: "600", fontSize: "16px" }}>Upload Img or video</div>
                          </Spin>
                        </div>
                      </Form.Label>
                      <Form.Control className="d-none" type="file" name="media" onChange={fileUploadsEnd} />
                    </Form.Group>
                  </div>
                </div>

                <div className="col-12 text-center">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="submit-btn"
                    size="large"
                    disabled={loading}
                  >
                    {loading ? "Uploading..." : "Upload Post"}
                  </Button>
                </div>
              </Form>
            ))}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ScoreLeaderKeeping;